import { Capacitor } from '@capacitor/core';
import { computed, ref } from 'vue';

export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.tecnonet.galidancia';

const DISMISS_STORAGE_KEY = 'galidancia_install_banner_dismissed_v1';

function isAndroidBrowser(): boolean {
  if (typeof navigator === 'undefined') {
    return false;
  }
  return /Android/i.test(navigator.userAgent);
}

function isDismissed(): boolean {
  try {
    return localStorage.getItem(DISMISS_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

function isStandaloneWebApp(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  const nav = window.navigator as Navigator & { standalone?: boolean };
  return window.matchMedia('(display-mode: standalone)').matches || nav.standalone === true;
}

export function useInstallAppBanner() {
  const dismissed = ref(isDismissed());

  const visible = computed(
    () =>
      !Capacitor.isNativePlatform() &&
      !dismissed.value &&
      !isStandaloneWebApp() &&
      isAndroidBrowser()
  );

  function dismiss(): void {
    dismissed.value = true;
    try {
      localStorage.setItem(DISMISS_STORAGE_KEY, '1');
    } catch {
      /* noop */
    }
  }

  return {
    visible,
    dismiss,
    playStoreUrl: PLAY_STORE_URL,
  };
}
